import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        error: {
            redirectButtonText: string;
        };
    };
};

export const messagesES: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        success: {
            verificationOnly: "SheerID solo maneja la verificación. Ahora que está aprobado, dirija todas las preguntas sobre los términos de promoción o el uso del código al servicio de atención al cliente de <a href='https://www.timberland.co.uk/customer-service/contact-us.html?geoRedirect=true' target=_blank class='sid-link' >Timberland/a>.",
        },
        error: {
            redirectButtonText: 'CONTINUAR TIMBERLAND',
        },
    },
};
